<div>
    <res-generic-grid [gridName]="gridName" [automationId]="automationId" [helpIndex]="helpIndex"
        [headerTemplate]="headerTemplate" [(isBusy)]="gridIsBusy" [(isBusyMessage)]="gridBusyMessage"
        [columnDefs]="columnDefs" [requestInfo]="requestInfo" [contextMenuOptions]="contextMenuOptions"
        [gridContext]="gridContext">
    </res-generic-grid>
    <ng-template #headerTemplate>
        <div class='parent-header'>
            <span>Deleted Projects</span>
        </div>
    </ng-template>
    <a download #downloadLink hidden target="_blank"></a>
</div>